import { useState } from 'react';
import {
    IconButton,
    Menu,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Grid,
    Typography,
    Box
} from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import { useSelector,useDispatch } from 'react-redux';
import { getProductItemsAsDict } from 'services/redux/reducers/slice';
import { getProductCategoryItemsAsDict } from 'services/redux/reducers/productCategorySlice';
import { cartActions } from 'services/redux/reducers/slice';
import ServiceFileUpload from './ServiceFileUpload';

const ServiceIcon = () => {
    const productsDict = useSelector(getProductItemsAsDict);
    const productCategoriesDict = useSelector(getProductCategoryItemsAsDict);
    const [anchorEl, setAnchorEl] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [description, setDescription] = useState('');
    const [selectedProduct, setSelectedProduct] = useState('');
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const dispatch = useDispatch();






    const nonPhysicalCategories = Object.values(productCategoriesDict)
        .filter(category => category.is_physical === false);
    const nonPhysicalProducts = Object.values(productsDict)
        .filter(product => 
            product.categories.some(categoryId => 
                nonPhysicalCategories.some(category => category.id === categoryId)
            )
        );
    const categoryProducts = selectedCategory
        ? Object.values(productsDict).filter(product =>
            product.categories.includes(selectedCategory.id) &&
            !product.is_physical
        )
        : [];

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCategorySelect = (category) => {
        setSelectedCategory(category);
        setDialogOpen(true);
        handleClose();
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        setSelectedCategory(null);
        setDescription('');
        setSelectedProduct('');
        setUploadedFiles([]);
    };

    const handleSubmit = () => {
        if (selectedProduct) {
            dispatch(cartActions.setCart([{
                itemId: selectedProduct.id,
                action: "add",
                count: 1,
                description: description,
                files: uploadedFiles, // Files for service request
            }]));

            handleDialogClose();
        }
    };

    return (
        <>
            <IconButton 
                onClick={handleClick}
                sx={{ 
                    color: 'primary.main',
                    '&:hover': { color: 'text.secondary' }
                }}
            >
                <ConstructionIcon />
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {nonPhysicalCategories.map((category) => (
                    <MenuItem 
                        key={category.id}
                        onClick={() => handleCategorySelect(category)}
                    >
                        {category.title}
                    </MenuItem>
                ))}
            </Menu>

            <Dialog 
                open={dialogOpen} 
                onClose={handleDialogClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    {selectedCategory?.title}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} sx={{ mb: 2, mt: 1 }}>
                        {categoryProducts.map((product) => (
                            <Grid item xs={4} key={product.id}>
                                <Box
                                    onClick={() => setSelectedProduct(product)}
                                    sx={{
                                        cursor: 'pointer',
                                        border: selectedProduct?.id === product.id ? 
                                            '2px solid #6bc637' : '1px solid #ddd',
                                        borderRadius: 1,
                                        p: 1,
                                        textAlign: 'center',
                                        transition: 'border-color 0.2s ease',
                                        height: product.image ? '200px' : '80px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between'
                                    }}
                                >
                                    {product.image && (
                                        <img 
                                            src={product.image}
                                            alt={product.title}
                                            style={{ 
                                                width: '100%',
                                                height: '120px',
                                                objectFit: 'contain',
                                                marginBottom: '8px'
                                            }}
                                        />
                                    )}
                                    <Box sx={{ flexGrow: 1 }}>
                                        <Typography 
                                            variant="caption" 
                                            sx={{
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                lineHeight: 1.2,
                                                fontSize: '12px',
                                                fontWeight: 'bold',
                                                mb: 0.5
                                            }}
                                        >
                                            {product.title}
                                        </Typography>
                                        {product.price > 0 && (
                                            <Typography 
                                                variant="caption" 
                                                sx={{
                                                    color: 'primary.main',
                                                    fontWeight: 'bold',
                                                    fontSize: '13px',
                                                    display: 'block'
                                                }}
                                            >
                                                ₹{product.price.toLocaleString('en-IN')}
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Description"
                        fullWidth
                        multiline
                        rows={4}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Please describe your service request..."
                    />
                    <ServiceFileUpload
                        files={uploadedFiles}
                        setFiles={setUploadedFiles}
                        maxFiles={4}
                        maxSizeMB={100}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>Cancel</Button>
                    <Button 
                        onClick={handleSubmit} 
                        variant="contained"
                        disabled={!selectedProduct}
                    >
                        Add to Cart
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ServiceIcon;